import React from 'react';
import PoseItem from '../../../../shared/poseItem/PoseItem';
import { imageIntentGalleryOf } from '../../../../shared/protectedImage/imageIntentGallery';

interface CroppedImage {
  id: unknown;
  url: string;
  name: string;
}

interface Pose {
  id: unknown;
  url?: string;
  cropped_images?: CroppedImage[];
}

interface PoseEntryProps {
  pose: Pose;
  poseSelectionIds: unknown[];
  selectedCropIds: Set<unknown>;
  onSelect: (poseId: unknown, cropIndex?: number | null) => void;
}

const PoseEntry: React.FC<PoseEntryProps> = ({
  pose,
  poseSelectionIds,
  selectedCropIds,
  onSelect,
}) => {
  // A price-list-matched pose pooled from a sibling's gallery carries its own
  // gallery; save-intent reports on it must name that gallery, not the order's.
  const intentGallery = imageIntentGalleryOf(pose);

  if (pose.cropped_images && pose.cropped_images.length > 0) {
    return (
      <>
        {pose.cropped_images.map((croppedImage, i) => {
          const isSelected =
            poseSelectionIds.includes(pose.id) &&
            selectedCropIds.has(croppedImage.id);
          return (
            <PoseItem
              key={`${pose.id}-${croppedImage.name}`}
              onClick={() => onSelect(pose.id, i)}
              intentGallery={intentGallery}
              src={croppedImage.url}
              alt=""
              name={`${croppedImage.name}${isSelected ? ' ✓' : ''}`}
            />
          );
        })}
      </>
    );
  }

  return (
    <PoseItem
      onClick={() => onSelect(pose.id)}
      intentGallery={intentGallery}
      src={pose.url}
      name=""
      onContextMenu={(event: React.MouseEvent) => event.preventDefault()}
    />
  );
};

export default PoseEntry;
